import PreferredCourseBadgeIcon from 'ui-component-library/icons/preferred-course.svg'

type Props = {
  className?: string
  preferredCourseBadgeLabelText?: string
}

function PreferredCourseBadge(props: Props) {
  const { className, preferredCourseBadgeLabelText } = props

  return (
    <PreferredCourseBadgeIcon
      aria-label={preferredCourseBadgeLabelText}
      role='img'
      className={className}
    />
  )
}

export default PreferredCourseBadge
